import React, { useEffect, useState } from "react";
import { UserContextSelectors } from "../../redux/selectors";
import { AccountDashboard } from "../AccountDashboard";
import { Brand } from "../../configurations";
import { FormattedMessage } from "react-intl";
import LastLogin from "../LastLogin";
import { LocalizationMessages } from "../../localization/messages";
import Logo from "../Logo";
import { MiniCashier } from "../MiniCashier";
import classNames from "classnames";
import { useInnerMenuTransition } from "../../hooks";
import { useSelector } from "react-redux";
import { BrandUtils } from "../../utils/brandUtils";
import { MenuChunk } from "./index";
import LoyaltyIndication from "../LoyaltyIndicator/LoyaltyIndicatorBox";
import { TrackingInfo } from "../tracking/TrackingInfoUserArea";
import { PoweredByContainer } from "./LeftAreaPCWrapper";
import { useTheme } from "styled-components";

const LeftAreaPC = () => {
  const isPC = useSelector(UserContextSelectors.isPC);
  const brandId = useSelector(UserContextSelectors.brandId);
  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);
  const isMobile = useSelector(UserContextSelectors.isMobile);
  const overflowVisible = useInnerMenuTransition();
  const theme = useTheme();

  const [accountWrapperClasses, setAccountWrapperClasses] =
    useState("accountAreaWrapper");

  useEffect(() => {
    setAccountWrapperClasses(
      classNames("accountAreaWrapper", {
        overflowVisible
      })
    );
  }, [overflowVisible]);

  if (!isPC) return null;

  switch (brandId) {
    case Brand.Sport_Scasino: {
      return (
        <React.Fragment>
          <div className={accountWrapperClasses}>
            <Logo />
            <div className="nav-scrollbar">
              <AccountDashboard />
              {!isMobile && isAuthenticated && (
                <LoyaltyIndication trackingInfo={TrackingInfo} />
              )}
              <MenuChunk />
              <PoweredByContainer color={theme.general.brandsColors.casino}>
                <FormattedMessage
                  {...LocalizationMessages.poweredBy888Casino}
                />
              </PoweredByContainer>
              <LastLogin />
            </div>
          </div>
        </React.Fragment>
      );
    }
    case Brand.Sport_Spoker: {
      return (
        <React.Fragment>
          <div className={accountWrapperClasses}>
            <Logo />
            <div className="nav-scrollbar">
              <AccountDashboard />
              {!isMobile && isAuthenticated && (
                <LoyaltyIndication trackingInfo={TrackingInfo} />
              )}
              <MenuChunk />
              {!BrandUtils.isPokerClient() && (
                <PoweredByContainer color={theme.general.brandsColors.poker}>
                  <FormattedMessage
                    {...LocalizationMessages.poweredBy888poker}
                  />
                </PoweredByContainer>
              )}
              <LastLogin />
            </div>
          </div>
        </React.Fragment>
      );
    }
    default:
      return (
        <React.Fragment>
          <div className={accountWrapperClasses}>
            <Logo />
            <div className="nav-scrollbar">
              <AccountDashboard />
              {!isMobile && isAuthenticated && (
                <LoyaltyIndication trackingInfo={TrackingInfo} />
              )}
              <MenuChunk />
              {BrandUtils.isPokerClient() && (
                <PoweredByContainer color={theme.general.brandsColors.sport}>
                  <FormattedMessage
                    {...LocalizationMessages.poweredBy888Sport}
                  />
                </PoweredByContainer>
              )}
              <LastLogin />
            </div>
          </div>
          <MiniCashier />
        </React.Fragment>
      );
  }
};

export default React.memo(LeftAreaPC);
